import { defineComponent as _defineComponent } from 'vue'
interface Props {
  text?: string;
  isLoading?: boolean;
  disabled?: boolean;
  width?: string;
  dataCy?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonSubmit',
  props: {
    text: { default: '' },
    isLoading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    width: { default: '100%' },
    dataCy: { default: 'submit' }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text: string, isLoading: boolean, disabled: boolean, width: string, dataCy: string };





const handleClick = (e: MouseEvent): void => {
  if (!props.isLoading) {
    emit('click', e);
  }
};

return { __sfc: true,props, emit, handleClick }
}

})